import http from '@/plugins/http';
import {
  type Project,
  projectResponseSchema,
  type Projects,
  projectSchema,
  projectsSchema,
} from '@/types/project';
import { handleError } from './errors';
import { memoize } from '@/services/cache';
import ExpiryMap from 'expiry-map';

export async function getProjects(withUserDetails = true): Promise<Projects> {
  return handleError(async () => {
    const response = await http.get('/api/projects', {
      params: {
        with_user_details: withUserDetails,
      },
    });
    return projectsSchema
      .parse(response.data)
      .sort((a, b) => b.updated_at.localeCompare(a.updated_at));
  });
}
export const projectsCache = new ExpiryMap(5 * 60 * 1000);
export const memoizedGetProjects = memoize(getProjects, projectsCache);

export async function getProject(id: string): Promise<Project> {
  return handleError(async () => {
    const response = await http.get(`/api/projects/${id}`);
    return projectSchema.parse(response.data);
  });
}

export const memoizedGetProject = memoize(getProject);

export function createProject(projectName: string, projectDescription: string | null) {
  return handleError(async () => {
    const createProjectResponse = await http.post('/api/projects', {
      body: { name: projectName, description: projectDescription },
    });

    return projectResponseSchema.parse(createProjectResponse.data);
  });
}

export function updateProject(
  projectId: string,
  projectName: string,
  projectDescription: string | null
) {
  return handleError(async () => {
    await http.patch(`/api/projects/${projectId}`, {
      body: { name: projectName, description: projectDescription },
    });
  });
}

export function deleteProject(projectId: string) {
  return handleError(async () => {
    return await http.delete(`/api/projects/${projectId}`);
  });
}
